module.exports = __webpack_public_path__ + "img/RunCircleOutlined.e46bb6ee.svg";